
/**
 * 将带连字符的字符串转换为驼峰命名法
 * 
 * 此函数接收一个字符串参数，该参数可能包含连字符
 * 它的目标是移除这些连字符，并将紧随连字符后的字母转换为大写
 * 从而形成驼峰命名法的字符串
 * 
 * 例如:
 * 'hello-world' => 'helloWorld'
 * 'css-grid' => 'cssGrid'
 * 
 * @param input 需要被转换的字符串
 * @returns 返回一个驼峰命名法的字符串
 */
export const camelize = (input: string) => {
  return input.replace(/\-(\w)/g, char => {
    return char.slice(1).toUpperCase();
  });
};


/**
 * 将驼峰命名法的字符串转换为带连字符的字符串
 * 例如，"camelCase"变为"camel-case"
 * 
 * @param str 驼峰命名法的字符串
 * @returns 带连字符的字符串
 */
export function hyphenate (str: string) {
  // 使用正则表达式匹配驼峰中的大写字母，并在其前加连字符
  // 然后将整个字符串转换为小写
  return str.replace(/([A-Z])/g, '-$1').toLowerCase();
}